export default "__VITE_ASSET__DzSIXB6Q__"